import React, { useCallback } from 'react';
import cn from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Notification } from 'ksnm-common-ui/lib/Notification';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';
import type { ReactElement } from 'react';

import styles from './ValueWithCopy.module.scss';

interface ICellWithCopy {
  // Если в children JSX.Element надо вручную навешивать на этот элемент
  // overflow: hidden и text-overflow: ellipsis для отображения многоточия
  children: string | number | ReactElement;
  needOverflow?: boolean;
  value?: string;
}

export const ValueWithCopy = ({ children, value, needOverflow }: ICellWithCopy): ReactElement | null => {
  const onCopy = useCallback(
    async (e) => {
      e.stopPropagation();
      await navigator.clipboard.writeText(value ?? (children as string));

      Notification({
        message: 'Значение скопировано в буфер обмена',
        duration: 1.5,
        type: 'success',
      });
    },
    [children, value],
  );

  if (!children) return null;

  return (
    <div className={cn(styles.value, { [styles.hiddenTextBlock]: needOverflow })}>
      <Tooltip content={needOverflow ? children : undefined}>
        <div className={needOverflow ? styles.hiddenText : undefined}>{children}</div>
      </Tooltip>

      <Tooltip content="Копировать">
        <div className={styles.copy} onClick={onCopy}>
          <Icon name="copy" />
        </div>
      </Tooltip>
    </div>
  );
};
